import Component from '@bythepixel/component-loader';
import { remove } from 'cart-localstorage';

export default class RemoveFromCart extends Component {
  static selector = '[data-comp-remove-from-cart]';

  constructor(containerEl) {
    super(containerEl);
    this.productData = this.$container.dataset;
    this.events();
  }

  events() {
    this.$container.addEventListener('click', () => {
      remove(this.productData.productId);
    });
  }
}
